<div class="flex justify-between px-6 py-4 border-b border-b-gray-100 -mx-6 -mt-6">
  <h3 class="text-gray-900 font-semibold"><ng-content></ng-content></h3>
  <app-button-icon icon="/assets/images/icon-close.svg" (click)="close()"></app-button-icon>
</div>
